module.exports = __webpack_public_path__ + "static/media/reference_library_icon.95eb3b2d.svg";